import DatePicker from 'react-datepicker'
import { registerLocale, setDefaultLocale } from 'react-datepicker'
import { vi } from 'date-fns/locale'
import {CustomDatePickerProps} from "models/model";

registerLocale('vi', vi)
setDefaultLocale('vi')


export default function CustomDatePicker({
                                             selected = '',
                                             onChange,
                                             placeholder,
                                             minDate,
                                             maxDate,
                                             disabled = false,
                                             className = '',
                                             id,
                                             name,
                                             required = false,
                                         }: CustomDatePickerProps) {
    return (
        <div className={`relative ${className}`}>
            <DatePicker
                selected={selected ? new Date(selected) : undefined}
                onChange={onChange}
                locale="vi"
                dateFormat="dd/MM/yyyy"
                placeholderText={placeholder}
                minDate={minDate}
                maxDate={maxDate}
                disabled={disabled}
                id={id}
                name={name}
                required={required}
                className="w-full transition-all duration-200"
                calendarClassName="!border !border-gray-200 !rounded-lg !shadow-sm !mt-1"
                dayClassName={() => "!text-gray-800 hover:!bg-gray-100"}
                weekDayClassName={() => "!text-gray-600 !font-medium"}
                monthClassName={() => "!p-2"}
                yearClassName={() => "!p-2"}
                calendarStartDay={1}
                popperClassName="react-datepicker-popper"
                wrapperClassName="w-full"
                showPopperArrow={false}
                renderCustomHeader={({
                                         date,
                                         decreaseMonth,
                                         increaseMonth,
                                         prevMonthButtonDisabled,
                                         nextMonthButtonDisabled,
                                     }) => (
                    <div className="flex items-center justify-between px-2 py-1">
                        <button
                            onClick={decreaseMonth}
                            disabled={prevMonthButtonDisabled}
                            type="button"
                            className={`p-1.5 rounded-lg hover:bg-gray-100 transition-colors ${
                                prevMonthButtonDisabled ? 'opacity-50 cursor-not-allowed' : ''
                            }`}
                            aria-label="Tháng trước"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5 text-gray-600"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                />
                            </svg>
                        </button>

                        <span className="text-sm font-semibold text-gray-800">
                            {date.toLocaleDateString('vi-VN', { month: 'long', year: 'numeric' })}
                        </span>

                        <button
                            onClick={increaseMonth}
                            disabled={nextMonthButtonDisabled}
                            type="button"
                            className={`p-1.5 rounded-lg hover:bg-gray-100 transition-colors ${
                                nextMonthButtonDisabled ? 'opacity-50 cursor-not-allowed' : ''
                            }`}
                            aria-label="Tháng sau"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5 text-gray-600"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clipRule="evenodd"
                                />
                            </svg>
                        </button>
                    </div>
                )}
            />
        </div>
    )
}